const COMPONENT_PREFIX = "one-widget";

export const ONE_WIDGET_TEST_IDS = {
    CONTAINER: `${COMPONENT_PREFIX}-container`,
    VIEW_DETAILS_FOOTER: `${COMPONENT_PREFIX}-footer`,
    VIEW_DETAILS_FOOTER_HEADING: `${COMPONENT_PREFIX}-footer-heading`,
    VIEW_DETAILS_FOOTER_CTA: `${COMPONENT_PREFIX}-footer-cta`,
    HEADER: `${COMPONENT_PREFIX}-header`,
    HEADER_LOGO: `${COMPONENT_PREFIX}-header-logo`,
    WATERMARK_BG_LOGO: `${COMPONENT_PREFIX}-logo`,
    BENEFITS_CONTAINER: `${COMPONENT_PREFIX}-benefits`,
    BENEFITS_LIST_ITEM: `${COMPONENT_PREFIX}-benefits-list-item-{0}`,
    DELIVERY_TAG_INFO: `${COMPONENT_PREFIX}-delivery-tag-info`,
    DELIVERY_TAG_COUNT: `${COMPONENT_PREFIX}-delivery-tag-count`,
    DELIVERY_TAG_COUNT_TEXT: `${COMPONENT_PREFIX}-delivery-tag-count-text`,
    SELECT_CONTAINER: `${COMPONENT_PREFIX}-select-container`,
    CHANGE_PLAN: `${COMPONENT_PREFIX}-change`,
    REMOVE_PLAN: `${COMPONENT_PREFIX}-remove`,
    ADD_PLAN: `${COMPONENT_PREFIX}-add`,
    BADGE: `${COMPONENT_PREFIX}-badge`,
    ONELOGO: `${COMPONENT_PREFIX}-logo`,
};
